import React from 'react'
// react component for creating dynamic tables
import ReactTable from 'react-table'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
// @material-ui/icons
import WhereToVote from '@material-ui/icons/WhereToVote'
import ZoomIn from '@material-ui/icons/ZoomIn'
// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import Button from 'components/CustomButtons/Button.jsx'
import Card from 'components/Card/Card.jsx'
import CardBody from 'components/Card/CardBody.jsx'

// general api service
import { finishPaymentForApplication, retrieveDataUsingGraphQL } from '../../services/generalServiceAPI'
import { titleCase, jsonPP, logger, reactTableFilterCaseInsensitive } from '../utility/utility'
import appContext from '../../services/context'
import remove from 'lodash/remove'
import isEmpty from 'lodash/isEmpty'
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.jsx'
import swal from 'sweetalert'

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
  // .ReactTable:{
  //   width: "100vw",
  //   height: "100vh"
  // },
  pbarRoot: {
    height: '20px',
  },
  progress: {
    margin: '0px',
    width: '100%',
  },
  linearBarColorPrimary: {
    backgroundColor: '#dadada',
  },
  inProress: {
    backgroundColor: '#999999', //'#ddbf00'
  },
  completed: {
    backgroundColor: '#40ab0c',
  },
  rejected: {
    backgroundColor: '#f00',
  },
}
// const shortenDescription = description => {
//   const temp = description ? String(description) : ''
//   const s = temp.substr(0, temp.length > 50 ? 50 : temp.length)
//   return <div onClick={() => swal(temp)}>{s.length >= 50 ? s + ' ...' : s}</div>
// }

const applicationBrief = ({ type, expenseType, expenseOrProcurement, creator, createdOn, archived, description, reason, ...others }) => {
  try {
    const getInfo = () => {
      const temp = type.id === 0 ? (isEmpty(description) ? '' : description + ' ') : isEmpty(reason) ? '' : reason + ' '
      const s = temp.substr(0, temp.length > 50 ? 50 : temp.length)
      return <div onClick={() => swal(temp)}>{s.length >= 50 ? s + ' ...' : s}</div>
    }
    return {
      ...others,
      short: type.short,
      category: type.id === 0 ? `${expenseOrProcurement}` : type.short,
      type: type.id === 0 ? `${expenseType.name}` : 'N/A',
      creator: titleCase(creator.name),
      // description: shortenDescription(description),
      archivedBy: archived.user ? titleCase(archived.user.firstname + ' ' + archived.user.lastname) : 'No Body',
      archivedOn: archived.on ? archived.on : 'N/A',
      info: getInfo(),
    }
  } catch (error) {
    // somehow a GAT is saved without expenseType, it will error out and result in no application is displayed
    logger('[ApplicationTable][applicationBrief]: ', error, true)
  }
}
class ApplicationTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: {},
      // when this is true, the table will wait for rendering
      loading: true,
      filtered: [],
      sorted: [],
      pageNumber: 0,
      pageSize: 10,
    }

    this.pullingData = this.pullingData.bind(this)
  }
  static contextType = appContext
  pullingData(args) {
    let query
    let variables
    // get basic info of application
    query = `
    query Applications($userId: ID!,$companyId: ID!, $role: Int, $status: String, $scope: String, $textSearch: String,$pageNumber: Int, $pageSize: Int, $filtered: String, $sorted: String){
      applications(userId: $userId,companyId:$companyId, role:$role, status: $status, scope: $scope, textSearch: $textSearch,pageNumber:$pageNumber, pageSize:$pageSize, filtered:$filtered, sorted: $sorted) {
          pages
          applications {
            id
            description
            reason
            type {
              id
              short
            }
            expenseType{
              name
            }
            expenseOrProcurement
            payTo
            amount
            currency
            startDate
            endDate
            creatorId
            creator{
              id
              name
            }
            createdOn
            activeStep
            lastLevelToSign
            lastModifiedOn
            status
            archived {
              user {
                firstname
                lastname
              }
              on
            }
          }
        }
      }
    `

    logger('[ApplicationTable][pullingData][1]:', { ...this.props }, true)
    /*
      1) when clicking on menu to route: props->history->location->(pathname, state)
      2) when pushing history to route:  props->location->blah
    */
    const { pageNumber, pageSize, filtered, sorted } = { ...this.state, ...args }
    logger('[ApplicationTable][pullingData][1]:', { ...this.props, pageNumber, pageSize, filtered, sorted, ...args }, true)

    const { status, scope, applications, location } = this.props
    if (typeof applications === 'undefined') {
      variables = {
        userId: this.context.user ? this.context.user.id : '',
        companyId: this.context.user.companyId,
        role: this.context.user.roleID,
        status,
        scope,
        textSearch: location ? location.textSearch : '',
        pageNumber,
        pageSize,
        filtered: JSON.stringify(filtered),
        sorted: JSON.stringify(sorted),
      }
      this.setState({ loading: true })
      retrieveDataUsingGraphQL(query, variables)
        .then((response) => {
          if (response.ok) {
            // console.log(response)
            return response.json()
          } else {
            logger('[ApplicationTable][pullingData][2]: ', response, true)
            response.text().then((error) => swal('Error', error, 'error'))
            // throw new Error('Something wrong ' + JSON.stringify(variables))
          }
        })
        .then(({ data }) => {
          logger('[ApplicationTable][pullingData][3]: ', data, true)
          const { pages, applications } = data.applications
          this.setState({
            data: {
              ...this.state.data,
              // creator 不存在的时候会出问题， 因为不存在可以定是错误， 99% from testing, so just 过滤掉
              applications: isEmpty(applications) ? [] : applications.filter((a) => !isEmpty(a.creator)).map((a) => applicationBrief(a)),
            },
            pages,
            loading: false,
          })
        })
        .catch((e) => logger('[ApplicationTable][pullingData][4]: ', e.message, true))
    }
  }
  // shouldComponentUpdate(nextProps, nextState) {
  //   if (this.props.location.textSearch !== nextProps.location.textSearch) {
  //     console.log({ nextProps })
  //     this.pullingData()
  //   }
  //   return true
  // }
  componentDidUpdate() {
    // console.log(this.props.location.textSearch)
    if (this.props.location && this.props.location.textSearch) this.pullingData()
  }
  async componentDidMount() {
    const filter = localStorage.getItem('applicationFilter')
    await this.setState(JSON.parse(filter))
    this.pullingData()
  }
  componentWillUnmount() {
    const { filtered } = this.state
    localStorage.setItem('applicationFilter', JSON.stringify({ filtered }))
  }
  onRowClick = (state, rowInfo, instance) => {
    return rowInfo
      ? {
          style: {
            background: rowInfo.index % 2 === 0 ? '#e0e0e0' : '#ffffff',
            color: 'black',
            height: '40px',
            margin: '2px',
          },
        }
      : {}
  }
  //getTdProps={this.onRowClick}
  render() {
    // 如果有上层传入application data,就用他们显示， 否则上层应该传入参数，用此component自己从数据库查询获取数据
    const { classes, history, applications } = this.props
    let data = typeof applications === 'undefined' ? this.state.data.applications : applications.filter((a) => !isEmpty(a)).map((a) => applicationBrief(a))
    logger('[ApplicationTable][render][0]: ', { data })

    if (isEmpty(data)) data = [{}]
    return (
      <GridContainer>
        <Card>
          <CardBody>
            <ReactTable
              data={data}
              defaultFilterMethod={(filter, row) => reactTableFilterCaseInsensitive(filter, row)}
              loading={this.state.loading}
              filterable
              // pagination starts
              onFilteredChange={(filtered) => {
                const filterChangedTimer = setTimeout(this.pullingData, 1000)
                clearTimeout(this.state.filterChangedTimer)
                this.setState({ filtered, filterChangedTimer })
              }}
              onSortedChange={(sorted) => {
                this.setState({ sorted })
                this.pullingData({ sorted })
              }}
              manual
              pages={this.state.pages}
              page={this.state.pageNumber}
              onPageChange={(pageNumber) => {
                this.setState({ pageNumber })
                this.pullingData({ pageNumber })
              }}
              onPageSizeChange={(pageSize) => {
                this.setState({ pageSize })
                this.pullingData({ pageSize })
              }}
              // pagination ends
              // getTrProps={reactTableRowCustomization}
              //onResizedChange={(newResized, event) => {console.log('resize', newResized, event)}}
              columns={[
                {
                  Header: () => <div style={{ textAlign: 'left' }}></div>,
                  id: 'actions',
                  maxWidth: 50,
                  sortable: false,
                  filterable: false,
                  accessor: (d) => {
                    return isEmpty(d.status) ? (
                      ''
                    ) : (
                      <div>
                        <Button
                          justIcon
                          // size='lg'
                          round
                          simple
                          onClick={(e) => {
                            history.push(`/application/${d.short.toLowerCase()}/${d.id}`)
                          }}
                          color='primary'
                          style={{ padding: '0px', margin: '0px' }}
                        >
                          <ZoomIn className={classes.icon} />
                        </Button>
                        {this.context.user.id === 98 ||
                        this.props.history.location.pathname === '/applications/finished' ||
                        this.context.user.id === 'zd794w' ? (
                          <Button
                            id={'received'}
                            name={'received'}
                            round
                            simple
                            onClick={async (e) => {
                              await finishPaymentForApplication({
                                id: d.id,
                                tableName: 'applications',
                                archived: {
                                  by: this.context.user.id,
                                  on: new Date(),
                                },
                                refetch: () => {
                                  const { applications } = this.state.data

                                  this.setState({
                                    applications: remove(applications, (a) => a.id === d.id),
                                  })
                                },
                              })
                            }}
                            justIcon
                            // size='lg'
                            color='primary'
                            style={{ padding: '0px' }}
                          >
                            <WhereToVote className={classes.icon} />
                          </Button>
                        ) : (
                          ''
                        )}
                      </div>
                    )
                  },
                },
                {
                  Header: 'ID',
                  id: 'id',
                  accessor: ({ id }) => (id ? id.substr(id.length - 4).toUpperCase() : ''),
                  width: 48,
                  sortable: false,
                },
                {
                  Header: 'Type',
                  minWidth: 120,
                  accessor: 'type',
                  Cell: ({ row }) => (
                    <div>
                      <span title={row._original.description}>{row.type}</span>
                    </div>
                  ),
                },
                {
                  Header: 'Vendor',
                  id: 'payTo',
                  accessor: 'payTo',
                  minWidth: 150,
                },
                {
                  Header: 'Amount',
                  id: 'amount',
                  accessor: ({ amount, currency }) => (amount ? `${amount.toMoney()}` : ''),
                  width: 110,
                },
                {
                  Header: 'Requestor',
                  accessor: 'creator',
                  width: 120,
                },
                {
                  Header: 'Description',
                  id: 'description',
                  accessor: 'info',
                  minWidth: 120,
                },
                {
                  Header: 'Archived By',
                  id: 'archived.by',
                  accessor: 'archivedBy',
                  mWidth: 120,
                  filterable: false,
                },
                {
                  Header: 'Archived On',
                  id: 'archived.on',
                  accessor: 'archivedOn',
                  width: 120,
                  filterable: false,
                },
                {
                  Header: '',
                  maxWidth: 0,
                },
              ]}
              defaultPageSize={10}
              showPaginationTop={false}
              showPaginationBottom //={true} //can be ignored
              showPageJump
              pageSizeOptions={[5, 10, 15, 20, 25, 50, 100]}
              className='-striped -highlight table'
              // style={{ .rt-table:{ overflow: 'hidden'} }}
            />
          </CardBody>
        </Card>

        {jsonPP(this.context)}
        {jsonPP(this.state.data.applications)}
        {/* {jsonPP(this.props.applications)} */}
        {/* {jsonPP(this.props)} */}
      </GridContainer>
    )
  }
}

export default withStyles(styles)(ApplicationTable)
